module.exports = __webpack_public_path__ + "img/组 18.0cb1d120.png";